import { produce } from 'immer'

import { createSelector, createSlice } from '@reduxjs/toolkit'

// import products from '@/data/products.json'

const initialState = {
  steps: [
    {
      title: 'cart',
      name: 'CART'
    },
    {
      title: 'payment',
      name: 'PAYMENT'
    },
    {
      title: 'confirmation',
      name: 'CONFIRMATION'
    }
  ],
  currentStep: 'CART',
  paymentMethod: 'CARD',
  paymentStatus: 'DEFAULT',
  paymentError: null,
  callAssistance: false,
  cart: []
  // cart: [...products.map(o => ({ ...o, qty: 1 })).slice(0, 8)]
}

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    addToCart: (state, { payload }) => {
      const existingItem = state.cart.find(item => item.id.toString() === payload.id.toString())
      
      if (existingItem) {
        return {
          ...state,
          cart: produce(state.cart, draftState => {
            const item = draftState.find(o => o.id.toString() === payload.id.toString())
            item.qty++
          })
        }
      } else {
        return {
          ...state,
          cart: [...state.cart, { ...payload, qty: 1 }]
        }
      }
    },
    removeFromCart: (state, { payload }) => {
      const itemToRemove = state.cart.find(o => o.id.toString() === payload.id.toString())

      return itemToRemove && itemToRemove.qty > 1 && !payload.all
        ? {
            ...state,
            cart: produce(state.cart, draftState => {
              draftState.find(o => o.id === itemToRemove.id).qty--
            })
          }
        : {
            ...state,
            cart: state.cart.filter(o => o.id.toString() !== payload.id.toString())
          }
    },
    setCurrentStep: (state, { payload }) => {
      return {
        ...state,
        currentStep: payload
      }
    },
    setPaymentMethod: (state, { payload }) => {
      return {
        ...state,
        paymentMethod: payload
      }
    },
    setPaymentStatus: (state, { payload }) => {
      return {
        ...state,
        paymentStatus: payload
      }
    },
    setPaymentError: (state, { payload }) => {
      return {
        ...state,
        paymentError: payload
      }
    },
    reset: state => {
      return {
        ...initialState
      }
    },
    setAssistance: (state, { payload }) => {
      return {
        ...state,
        callAssistance: payload
      }
    }
  }
})

const cartItems = state => state.cart

export const { setCurrentStep, addToCart, removeFromCart, setPaymentMethod, setPaymentError, reset, setPaymentStatus, setAssistance } =
  checkoutSlice.actions

export const cartTotalSelector = createSelector(cartItems, cart =>
  cart.length > 0 ? cart.map(o => o.qty * o.price).reduce((acc, current) => acc + current) : 0
)

export default checkoutSlice.reducer
